import React, { useMemo, useState } from 'react';
import { SearchIcon } from 'lucide-react';
import type { TourEntry } from '../../types/showcase';
interface TourEntryListProps {
  entries: TourEntry[];
  activeNumber: number | null;
  onHover: (n: number | null) => void;
  onSelect: (n: number) => void;
}
export function TourEntryList({
  entries,
  activeNumber,
  onHover,
  onSelect
}: TourEntryListProps) {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return entries;
    return entries.filter(e => [String(e.number), e.model, e.builder, e.address].some(f => f.toLowerCase().includes(q)));
  }, [entries, query]);
  return <div className="flex h-full flex-col" data-id="element-185" data-mp="3k24uqwm783mg">
      <label className="relative block" data-id="element-186" data-mp="3k13bi4v14atn">
        <span className="sr-only" data-id="element-187" data-mp="23o6drxyyia1m">Search homes, builders, or streets</span>
        <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-188" data-mp="23r0ubeeunapr" />
        <input type="search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search homes, builders, streets" className="w-full rounded-md border border-line bg-white py-2.5 pl-9 pr-3 text-sm text-ink placeholder:text-muted focus:border-navy focus:outline-none focus:ring-2 focus:ring-navy/20" data-id="element-189" data-mp="11l8qdz9czw3q" />
      </label>

      <ul className="mt-3 min-h-0 flex-1 divide-y divide-line overflow-y-auto rounded-lg border border-line bg-white" onMouseLeave={() => onHover(null)} data-id="element-190" data-mp="1kkcviwxs55q4">
        {filtered.map(e => {
        const active = activeNumber === e.number;
        const closed = e.status === 'closed';
        return <li key={e.number} data-id="element-191" data-mp="1pbcrnzz2rjrk">
              <button type="button" onMouseEnter={() => onHover(e.number)} onClick={() => onSelect(e.number)} className={`flex w-full items-start gap-3 px-3 py-2.5 text-left transition-colors duration-150 ${active ? 'bg-navy-light' : 'hover:bg-canvas'}`} data-id="element-192" data-mp="1pc4p7gc8frkh">
                <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white ${closed ? 'bg-muted' : 'bg-orange-deep'}`} data-id="element-193" data-mp="101i56lbn56af">
                  {e.number}
                </span>
                <span className="min-w-0" data-id="element-194" data-mp="1eobcp4ex57s2">
                  <span className={`block truncate text-sm font-semibold ${closed ? 'text-muted' : 'text-ink'}`} data-id="element-195" data-mp="1erpdi87xp8xe">{e.model}</span>
                  <span className="block truncate text-xs text-muted" data-id="element-196" data-mp="1npj8nftypwiz">
                    {e.builder}
                    {e.note ? ` · ${e.note}` : ''}
                  </span>
                </span>
              </button>
            </li>;
      })}
        {filtered.length === 0 && <li className="px-4 py-8 text-center text-sm text-muted" data-id="element-197" data-mp="3ufz5qoqtag5l">No homes match “{query}”.</li>}
      </ul>
    </div>;
}